export { SpacePermissionsTabKey } from '../src/tabs/spacePermissionKeys';

export const SPACE_PERMISSIONS_UPLIFT_M1_FF = 'confluence.frontend.space-perms-uplift.milestone-1';
